export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7368.898f350f.jpg";